const commentItems = [
  {
    name: '漫迷小李',
    text: '终于找到一个只收录完结漫画的网站了！追更好几年的几部漫画在这里一口气看到结局，感动到哭。下拉式阅读体验太爽了，不用翻页一直往下滑就行。',
    time: '3天前',
    tag: '热血漫画迷',
  },
  {
    name: '甜甜圈',
    text: '作为一个恋爱漫画重度爱好者，迷妹漫画的完结漫画大全简直是天堂。糖分超标，从初遇到结婚完整看完，不用等更新真的太幸福了。',
    time: '5天前',
    tag: '恋爱漫画迷',
  },
  {
    name: '推理控小王',
    text: '悬疑漫画追一半被吊胃口太痛苦了，感谢迷妹漫画收录了这么多完结推理漫画完整版，一次性解谜的体验无与伦比。推荐给所有推理迷！',
    time: '1周前',
    tag: '悬疑漫画迷',
  },
  {
    name: '异世界旅人',
    text: '异世界题材漫画我追了不下二十部，但很多都还在连载。迷妹漫画帮我找到了十几部已完结的异世界漫画全集，终于不用同时追十几部了。',
    time: '1周前',
    tag: '异世界漫画迷',
  },
  {
    name: '睡前读物',
    text: '每天睡前刷几话日常治愈完结漫画，心情都会变好。迷妹漫画的手机端竖屏阅读体验很好，躺床上单手操作也很方便。完结漫画大全每天都有新发现。',
    time: '2周前',
    tag: '日常漫画迷',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            读者心声
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自漫画迷的真实反馈，看看大家怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 max-w-6xl mx-auto">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="p-4 md:p-5 rounded-2xl bg-background-100 border border-background-200/60 transition-all duration-200 hover:-translate-y-1"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center shrink-0">
                  <span className="text-xs font-heading text-accent-600">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div className="min-w-0">
                  <span className="block text-sm font-semibold text-foreground-900 truncate">
                    {item.name}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3">
                {item.text}
              </p>
              <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}